import { Navigate, useLocation } from "react-router-dom";

/**
 * Synchronous route guard.
 * Checks for the auth token *before* rendering any protected content.
 * If no token is present, redirects to /login immediately with the
 * originally-requested path stored in state so the app can return after login.
 */
const RequireAuth = ({ children }: { children: JSX.Element }) => {
  const location = useLocation();
  const token = localStorage.getItem("token-name");

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default RequireAuth;
